import React, { useState, useEffect, useRef } from "react";
import DynamicForm from "../../stories/Forms/DynamicForm";
import {  createAccount as createAccountFields } from "../../stories/Forms/fields";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { createAccountSchema } from "../../stories/Forms/validationSchema";
import { createAccountUrl, postCoderurl } from "../../utils/constants";
import { BoxArrowInRight, XSquare } from "react-bootstrap-icons";
import useApis from "../../services/useAPI";
import { useLocation } from "react-router-dom";
import AccountCard from "../../stories/cards/AccountCard";
import ConfirmAccount from "../Account/ConfirmAccount";
import { fetchAddressOptions, getCountryFromPhone, removeCountryCodeForUkNumber } from "../../utils/utils";
import { Modal, Button } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import { useMediaQuery, } from "react-responsive";
import CloseModal from "../../assets/icons/close_modal.svg";


let typeResponse;
const CreateAccount = () => {
  const auth = useAuth();
  const location = useLocation();
  const [consentData, setConsentData] = useState(null);
  const { callApi, serverError, resultPost, loading } = useApis();
  const [password, setPassword] = useState("");
  const [finished, setFinished] = useState(false);
  const [toastShown, setToastShown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [addressLoading, setAddressLoading] = useState(false);
  const formikRef = useRef(null);
  const typeUrl = `/api/dashboard/check-consent`;
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const params = new URLSearchParams(location.search);
  const emailFromUrl = params.get('email');
  const [formData, setFormData] = useState({
    email: emailFromUrl || "",
    password: "",
    first_name: "",
    last_name: "",
    phone_number_primary: "",
    dob: "",
    home_postal_code: "",
    home_street_address: "",
    address_line_1: "",
    address_line_2: "",
    home_city: "",
    home_country: "",
    sex: "",
    identify_with_gender: null,
    ethnicity: "",
    policy_consent: false,
    service_consent: false,
    marketing_consent: false,
    recaptcha_token: "",
  });
  const [accountConfirmed, setAccountConfirmed] = useState(false);

  useEffect(() => {
    localStorage.setItem("isLoggedIn", false);
  });

useEffect(() => {
  const fetchTypeAndConsentData = async () => {
    const response = await callApi({}, typeUrl, "GET");
    if (response?.content) {
      setConsentData(response.content);
    }
  };
  fetchTypeAndConsentData();
}, []);

 const accountFields =
    auth?.isNonUKNumber === true
      ? createAccountFields.map((field) => {
          if (field.name === "phone_number_primary") {
            return {
              ...field,
              type: "advancePhoneNumber",
              controlId: "advancePhoneNumber",
              handleChange: (e, setFieldValue) => {
                setFieldValue(field.name, e.target.value);
              },
            };
          }

          return field;
        })
      : createAccountFields;
      
  useEffect(()=>{
    if(serverError === "Postcode lookup failed. Please try again later." ||
    serverError === "Invalid postcode format"){
      auth?.showToast(
          "Error",
          serverError,
          "../assets/mhc.png",
          <XSquare />,
        );
    }
  },[serverError])

  // Handle server errors
  useEffect(() => {
    if (serverError && !toastShown) {
      auth?.showToast("Error", serverError, "../assets/mhc.png", <XSquare />);
      setToastShown(true);
      setAccountConfirmed(false);
    }
  }, [serverError, toastShown, auth]);

  useEffect(() => {
    if (resultPost?.data && !toastShown) {
      auth?.showToast(
        "Success",
        "Account created successfully!",
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      setFinished(true);
      setToastShown(true);
    }
  }, [resultPost, toastShown, auth]);

  const handleCreateAccount = async (values) => {
    const rawNumber = values.phone_number_primary.trim().replace(/\s+/g, "");
           const bareNumber = removeCountryCodeForUkNumber(rawNumber).replace(
             /\s+/g,
             "",
           );
           const countryCode =
             values.phone_number_primary_country ||
             `${getCountryFromPhone(rawNumber)?.code  !== undefined ? '+' :'+44'}${getCountryFromPhone(rawNumber)?.code || ""}`;
    
           values.phone_number_primary = countryCode
             ? `${countryCode}${bareNumber}`
             : bareNumber;
    const payload = {
      email: values.email,
      password: values.password,
      first_name: values.first_name,
      last_name: values.last_name,
      mobile_number: `${values.phone_number_primary.trim().replace(/\s+/g, "")}`,
      dob: values.dob,
      home_postal_code: values.home_postal_code,
      home_street_address: values.home_street_address,
      sex: values.sex,
      identify_with_gender:
        values.identify_with_gender === "yes" ||
        values.identify_with_gender === "true" ||
        values.identify_with_gender === true,
      ethnicity: values.ethnicity,
      policy_consent: values.policy_consent,
      service_consent: values.service_consent,
      marketing_consent: values.marketing_consent,
      recaptcha_token: values.recaptcha_token,
      search: location?.search,
      declaration_of_consent: true,
      is_resend: false,
      other_home_adress: values.other_home_adress,
      address_line_1: values.address_line_1,
      address_line_2: values.address_line_2,
      home_city: values.home_city,
      home_country: values.home_country,
      email_mfa: auth.isNonUKNumber
    };

    setFormData(payload);

    setToastShown(false);

    // Call the API to create the account
    await callApi(payload, createAccountUrl, "POST");

    // Set accountConfirmed to true after submission
    setAccountConfirmed(true);
  };

  const handleCodeBlur = async (code, setFieldValue) => {
    const trimmedCode = code.replace(/\s+/g, "");

    // Early return if empty
    if (!trimmedCode) {
      setFieldValue("home_street_address", "");
      setAddressOptions([]);
      return;
    }

    await fetchAddressOptions({
      trimmedCode,
      callApi,
      postCoderurl,
      setAddressOptions,
      setFieldValue,
    });
  };

  const handleModalSubmit = () => {
    setConsentChecked(true);
    setShowModal(false);
    if (formikRef.current) {
      formikRef.current.setFieldValue("policy_consent", true);
    }
  };

  const handleOnChange = (e, setFieldValue) => {
    const { name, value } = e.target;

    if (name === "home_street_address" && value === "No results") {
      setFieldValue("address_line_1", "");
      setFieldValue("address_line_2", "");
      setFieldValue("home_city", "");
      setFieldValue("home_country", "UK");
    }

    if (name === "policy_consent") {
      const isCurrentlyChecked = formikRef.current?.values?.policy_consent;
      if (isCurrentlyChecked === false) {
        setShowModal(true);
        return;
      } else {
        setFieldValue(name, false);
        setConsentChecked(false);
        return;
      }
    }

    setFieldValue(name, value);
  };

  return (
    <>
      {accountConfirmed ? (
          <ConfirmAccount
            email={formData.email}
            loading={false}
            formData={formData}
          />
      ) : (
        <AccountCard
          createaccount={true}
          title="Create your account"
          finished={finished}
        >
          <DynamicForm
            formikRef={formikRef}
            fields={accountFields}
            onSubmit={handleCreateAccount}
            password={password}
            setPassword={setPassword}
            validationSchema={createAccountSchema}
            initialValues={formData}
            validateOnChange={false}
            handleCodeBlur={handleCodeBlur}
            addressLoading={addressLoading}
            addressOptions={addressOptions}
            validateOnBlur={true}
            isLoading={loading}
            handleChange={handleOnChange}
            error={serverError}
            enableReinitialize={true}
            setShowModal={setShowModal}
            showModal={showModal}
            consentChecked={consentChecked}
          />
        </AccountCard>
      )}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setConsentChecked(false);
        }}
        centered
        size="xl"
        backdrop="static"
        className="consent-modal"
      >
        {isMobile ? (
          <>
          <button
            className="custom-close-btn"
            onClick={() => {
              setShowModal(false);
              setConsentChecked(false);
            }}
          >
            <img src={CloseModal} alt="Close" />
          </button>
          <Modal.Header className="consent-header">
            <Modal.Title>Declaration of consent</Modal.Title>
          </Modal.Header>
          </>
        ) : ( 
        <Modal.Header closeButton className="consent-header">
          <Modal.Title>Declaration of consent</Modal.Title>
        </Modal.Header>
        )}
        <Modal.Body className="scrollable-consent">
          <div className="consent-form-middle">
            <ReactMarkdown>{consentData}</ReactMarkdown>
            {
              consentData && (
                <i className="text-muted fs-8 text-justify">
                  *In line with data retention guidelines as outlined in:
                  <ul>
                    <li>
                      NHS England Records Management Code of Practice (published
                      August 2021, updated August 2023).
                    </li>
                    <li>
                      Welsh Government Records Management Code of Practice for
                      Health and Social Care: A Guide to the Management of
                      Health and Care Records (published February 2022).
                    </li>
                    <li>
                      Scottish Government: Records Management: Code of Practice
                      for Health and Social Care (published August 2024).
                    </li>
                  </ul>
                </i>
              )}
          </div>
        </Modal.Body>

        <Modal.Footer className="consent-footer">
          <Button variant="green" onClick={handleModalSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateAccount;
